



















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-payment-checkout-status',
  components: {},
})
export default class PaymentCheckoutStatus extends Vue {
  @Prop({ type: String }) readonly status: string;
  @Prop({ type: String }) readonly invoiceToken: string;

  get moneyTransferConfirmationPageInfo(): string {
    return this.$store.getters['centerSettings/moneyTransferConfirmationPageInfo'];
  }

  getToken() {
    return this.$route.query?.token || null;
  }
}
